import { Filenames } from '../../filenames'

export default {
  companyLogo: Filenames.hdrLogo,
  companyName: 'HDR Rice Daubney',
  author: 'Brandon Reid',
  authorTitle: 'BIM Manager',
}
